<template>
  <div>
    <div class="row" v-if="loading">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="text-center text-primary my-2">
              <b-spinner class="align-middle mr-2"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </div>
        </div>
      </div>
    </div>

    <template v-if="!loading">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">
                {{ detail.address_street.toUpperCase() }},
                {{ detail.state.name.toUpperCase() }},
                {{ detail.city.toUpperCase() }}, {{ detail.zip_code }}
              </h4>
                 <form
                @submit.prevent="onSubmit"
                novalidate
                enctype="multipart/form-data"
                :class="
                  submitted
                    ? 'needs-validation was-validated'
                    : 'needs-validation'
                "
              >
                <input
                  type="hidden"
                  name="csrfmiddlewaretoken"
                  value="P27tGSg2RncTjAtrsgv4Cft93HKmAiLsI1XRtIrv6LZzVyZ39JkSoyAfpSETgke3"
                />

                <!-- Start Row -->
                <div class="row">
                  <!-- Start Col -->
                  <div class="col-lg-9">
                    <label for="organization_id">Organization*</label>
                    <select
                      name="organization"
                      class="form-control"
                      required=""
                      disabled=""
                    >
                      <option selected="selected">
                        {{ this.currentOrg.organization.name }}
                      </option>
                    </select>
                  </div>
                  <!-- End Col -->

                  <!-- Start Col -->
                  <div class="col-lg-3">
                    <label for="property_status_id">Property Status*</label>
                    <select
                      name="property_status"
                      id="property_status_id"
                      class="form-select"
                      v-model="selectedType"
                    >
                      <option value="active">Active</option>

                      <option value="expired">Expired</option>
                    </select>
                  </div>
                  <!-- End Col -->
                </div>
                <!-- End Row -->

                <p></p>

                <!-- Start Row -->
                <div class="row">
                  <!-- Start Col -->
                  <div class="col-lg-12">
                    <label for="">Address Type</label>
                    <ul id="address_type_id" class="checkbox inline">
                      <li>
                        <label for="address_type_id_0"
                          ><input
                            type="checkbox"
                            name="address_type"
                            value="service_location"
                            id="address_type_id_0"
                            class="checkbox inline"
                            v-model.trim="$v.address_type.$model"
                          />
                          Service Location</label
                        >
                      </li>
                      <li>
                        <label for="address_type_id_1"
                          ><input
                            type="checkbox"
                            name="address_type"
                            value="billing_address"
                            id="address_type_id_1"
                            class="checkbox inline"
                            v-model.trim="$v.address_type.$model"
                          />
                          Billing Address</label
                        >
                      </li>
                      <li>
                        <label for="address_type_id_2"
                          ><input
                            type="checkbox"
                            name="address_type"
                            value="headquarters"
                            id="address_type_id_2"
                            class="checkbox inline"
                            v-model.trim="$v.address_type.$model"
                          />
                          Headquarters</label
                        >
                      </li>
                    </ul>
                    <!-- <div
                      v-if="submitted && !$v.address_type.required"
                      class="invalid-tooltip"
                    >
                      This field is required
                    </div> -->
                  </div>
                  <!-- End Col -->
                </div>
                <!-- End Row -->

                <p></p>

                <!-- Start Button -->
                <div class="d-flex flex-wrap gap-2">
                  <button
                    class="btn btn-success"
                    :disabled="loadingAction"
                    type="submit"
                  >
                    Save
                  </button>
                  <button type="button" class="btn btn-light waves-effect" @click="$router.go(-1)">
                    <!-- <router-link
                      :to="
                        '/mpg/addresses/' + $route.params.id + '/organizations'
                      "
                      ></router-link
                    > -->
                    Cancel
                  </button>
                </div>
                <!-- End Button -->
              </form>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { addressesService } from '../services/addresses.service'
// import { required } from 'vuelidate/lib/validators'
import moment from 'moment'
import { router } from '../router'

export default {
  name: 'EditAddressesOrg',
  components: {},
  data () {
    return {
      address_type: [],
      submitted: false,
      loading: true,
      loadingAction: false,
      error: '',
      detail: {},
      currentOrg: {},
      selectedType: ''
    }
  },
  validations: {
    address_type: {}
  },
  computed: {},
  created () {
    if (!this.$route.params.id || this.$route.params.id === '') {
      router.push('/mpg/addresses/')
    }

    addressesService.getDataById(this.$route.params.id).then((rs) => {
      this.detail = rs
      this.loading = false
      this.currentOrg = this.detail.organizations_addresses.find((org) => {
        return (
          org.organization.organization_id.toString() ===
          this.$route.params.orgId
        )
      })
      this.selectedType = this.currentOrg.property_status
      this.address_type = this.currentOrg.address_type
    })
  },
  methods: {
    moment,
    onSubmit () {
      this.submitted = true
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      this.loadingAction = true
      const payload = {
        address_type: this.address_type,
        property_status: this.selectedType,
        address: this.$route.params.id,
        organization: this.$route.params.orgId
      }
      addressesService
        .updateOrgToAddress(payload, this.currentOrg.organization_address_id)
        .then(
          (rs) => {
            this.$nextTick(() => {
              this.$router.go(-1)
              // router.push(
              //   `/mpg/addresses/${this.$route.params.id}/organizations/`
              // )
            })
          },
          (error) => {
            this.error = error
            this.loadingAction = false
          }
        )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/EditAddressesOrg.vue